import { render } from "./HomePage.vue?vue&type=template&id=25228cb3&scoped=true"
import script from "@/assets/js/home.js?vue&type=script&defer=true&lang=js&external"
export * from "@/assets/js/home.js?vue&type=script&defer=true&lang=js&external"

import "@/assets/css/home.css?vue&type=style&index=0&id=25228cb3&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25228cb3"]])

export default __exports__